import React from 'react';

import {
  SubmitButton,
  Input,
  CenteredWidthAndHeightLayout,
  CenteredBoxSmall,
  SpacingBox,
  Alert,
  MobilePaddingLayout,
  Paragraph,
  LightH3,
  SpinnerIcon,
  FlexBox,
  VisibilityIcon,
  NonVisibilityIcon,
} from '../../Components';
import { getTranslateByScope } from '../../i18n';
import AppContext from '../../AppContext';
import { isStartingUp } from '../../selectors';
import useLogin from './useLogin';
import SchLogoImg from "../../assets/Logo.png";

const translate = getTranslateByScope('app.login');

const Login = () => (
  <CenteredWidthAndHeightLayout>
    <CenteredBoxSmall>
      <MobilePaddingLayout>
        <Form />
      </MobilePaddingLayout>
    </CenteredBoxSmall>
  </CenteredWidthAndHeightLayout>
);

export default Login;

const Form = () => {
  const context = React.useContext(AppContext);
  const {
    setEmail,
    setPassword,
    togglePasswordVisibility,
    handleLogin,
    requestError,
    submitting,
    isPasswordShown,
  } = useLogin();

  if (isStartingUp(context)) {
    return <Paragraph> ... Loading </Paragraph>;
  }

  return (
    <form onSubmit={handleLogin} style={{ marginTop: '10vh' }}>
      <FlexBox
        marginBottom='xl'
        justifyContent='center'
        style={{ width: '90%' }}
      >
        <img
          alt='logo'
          width='300px'
          src={SchLogoImg}
        />
      </FlexBox>

      <SpacingBox marginBottom='md' style={{ width: '90%' }}>
        {requestError.map((r) => (
          <SpacingBox marginBottom='sm'>
            <Alert visible={!!r} text={translate('requestError')} />
          </SpacingBox>
        ))}
      </SpacingBox>
      <SpacingBox marginBottom='lg'>
        <LightH3>{translate('title')}</LightH3>
      </SpacingBox>

      <SpacingBox marginBottom='lg'>
        <FlexBox style={{ width: '90%' }}>
          <Input
            name='email'
            autoComplete='email'
            type='email'
            onChange={setEmail}
            required
            autoFocus
            placeholder={translate('emailAddress.placeholder')}
          />
        </FlexBox>
      </SpacingBox>
      <SpacingBox marginBottom='lg'>
        <FlexBox flexDirection='row'>
          <FlexBox style={{ width: '90%' }}>
            <Input
              name='password'
              autoComplete='current-password'
              onChange={setPassword}
              type={isPasswordShown ? 'text' : 'password'}
              required
              placeholder={translate('password.placeholder')}
            />
          </FlexBox>
          <FlexBox marginLeft='sm'>
            {isPasswordShown ? (
              <NonVisibilityIcon onClick={togglePasswordVisibility} />
            ) : (
              <VisibilityIcon onClick={togglePasswordVisibility} />
            )}
          </FlexBox>
        </FlexBox>
      </SpacingBox>

      <FlexBox flexDirection='row' alignItems='center'>
        <SubmitButton
          onClick={handleLogin}
          type='submit'
          value={translate('submitButton.text')}
        />
        {submitting && (
          <SpacingBox marginLeft='md'>
            <SpinnerIcon />
          </SpacingBox>
        )}
      </FlexBox>
    </form>
  );
};
